import React, { useEffect } from "react";
import { logout } from "../redux/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../redux/app/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE, PTA_ROLE, FACILITATOR, PARTICIPANT, VIRTUAL } from "../utils/constants";

interface PublicRouteProps {
  children: any;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const accessToken = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes("accessToken")) as string) || "";
  const role = useAppSelector((state) => state.auth.role);
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const teacherMainRoute: any = useAppSelector((state) => state.auth.teacherMainRoute);
  const isKaton = useAppSelector((state) => state.auth.isKaton);
  const participantCode = useAppSelector((state) => state.auth.participantCode);
  const schoolType = useAppSelector((state) => state.auth.schoolType);

  //after login the user tried to redirect to the login page, restrict the user.
  useEffect(() => {
    if (role !== PTA_ROLE) {
      if (accessToken) {
        const Components = role === STUDENT_ROLE ? "/student-classroom" : teacherMainRoute
        if (Components === "/") {
          dispatch(logout());
        }
        navigate(Components);
      } else {
        dispatch(logout());
        if (location.pathname === "/teacher-select-class") {
          navigate("/");
        }
      }
    }
  }, [accessToken, navigate, dispatch, isKaton, participantCode]);

  return <>{children}</>;
};

export default PublicRoute;
